import $ from "jquery";

window.translationStrings = {};

if ($('html').attr('lang') === 'de') {
    window.translationStrings.prevSlide = 'Vorheriger Slide';
    window.translationStrings.nextSlide = 'Nächster Slide';
} else  {
    window.translationStrings.prevSlide = 'Previous slide';
    window.translationStrings.nextSlide = 'Next slide';
}
